import { useTranslation } from 'react-i18next'

import { Spinner } from '../common'
import Icon from '../icon'

interface LoadMoreProps {
  onClick: () => void
  isLoading: boolean
}

// Shared by the inbox modal and the /profile/inbox page so both page the list
// with the same control — the animated double-chevron the transaction pages use
// (financial-transaction / transaction-history / wagering-transaction all render
// this exact button), swapping in the spinner while the next page is in flight.
// Icon-only, so the translated copy becomes the accessible name.
const LoadMore = ({ onClick, isLoading }: LoadMoreProps) => {
  const { t } = useTranslation('inbox')

  if (isLoading) {
    return <Spinner containerStyle={{ height: '46px' }} spinnerSize={20} />
  }

  return (
    <button
      type="button"
      className="flx-ctr w-full pt-2 pb-3 px-4"
      onClick={onClick}
      aria-label={t('load-more')}>
      <Icon
        className="animate-arrowAnim stroke-txt"
        id="double-chevron-down"
        width="24"
        height="24"
      />
    </button>
  )
}

export default LoadMore
